// Initial colors

export const black = "#000";

export const grayDarker = "#363636";
export const grayDark = "#494949";
export const gray = "#7a7a7a";
export const grayLight = "#b5b5b5";
export const grayLighter = "#dbdbdb";

export const white = "#fff";

export const turquoise = "#00d1b2";
export const blue = "#3273dc";

export const primary = turquoise;
export const info = blue;

export const textGray = gray;

export const linkHover = grayDarker;



// WEBPACK FOOTER //
// ./styles/color.ts